import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-145a3b4b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "why" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "box_list" }
const _hoisted_4 = {
  span: 24,
  class: "item"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "image" }, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_typography_paragraph = _resolveComponent("a-typography-paragraph")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_typography_title, { level: 1 }, {
        default: _withCtx(() => [
          _createTextVNode(" 为什么选择星汉未来InfraPilot? ")
        ]),
        _: 1 /* STABLE */
      }),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.expand.content, (item) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_a_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, {
                  xs: 24,
                  md: 4
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_a_col, {
                  xs: 24,
                  md: 4
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_typography_title, { level: 5 }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.title), 1 /* TEXT */)
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1024 /* DYNAMIC_SLOTS */)
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1024 /* DYNAMIC_SLOTS */),
                _createVNode(_component_a_col, {
                  xs: 24,
                  md: 16
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_typography_paragraph, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.text), 1 /* TEXT */)
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1024 /* DYNAMIC_SLOTS */)
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1024 /* DYNAMIC_SLOTS */)
              ]),
              _: 2 /* DYNAMIC */
            }, 1024 /* DYNAMIC_SLOTS */)
          ]))
        }), 256 /* UNKEYED_FRAGMENT */))
      ]),
      _createCommentVNode(" <a-space :size=\"$Store.Public().isGridMatch('>=',$Enum.GridEnum.XL)?'large':'small'\">\n        <a-button type=\"link\" class=\"button_n_2\"\n                  @click=\"clickToCloud()\">\n          立刻在线体验\n        </a-button> "),
      _createCommentVNode("<a-button type=\"link\" class=\"button_1\""),
      _createCommentVNode("       @click=\"$Store.Page().openModal('modalFormCollection', 'deployment')\">"),
      _createCommentVNode("  预约私有化部署"),
      _createCommentVNode("</a-button>"),
      _createCommentVNode(" </a-space> ")
    ])
  ]))
}